import React from 'react'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { Mode, HeroForCareersPage } from 'marketing-site/src/library/components/HeroForCareersPage'
import { CTALink } from '../../library/elements/CTALink'

import {
  IHeroForCareersPage as IContentfulHeroForCareersPage,
  ICtaLink as IContentfulCtaLink,
  ISelect as IContentfulSelect,
} from 'marketing-site/@types/generated/contentful'
import { ILayout } from 'marketing-site/src/library/components/Hero'
import { IHeroContentAlignment } from 'marketing-site/src/library/components/Hero'

import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { transformCTAWithBackground } from '../elements/ContentfulCTALink'
import { transformVideoOrImage } from '../elements/ContentfulVideoOrImage'
import { transformSelect } from '../elements/ContentfulSelect'
import { LocationSelect } from './ContentfulLocationSelect'

export const ContentfulHeroForCareersPage = (data: IContentfulHeroForCareersPage) => (
  <EntryMarker entry={data}>
    {() => <HeroForCareersPage {...transformHeroForCareersPage(data)} />}
  </EntryMarker>
)

function getLayoutFromData(alignment: IHeroContentAlignment): ILayout {
  return {
    leftAlign: alignment === 'Left',
    compact: true,
  }
}

type ICTA = IContentfulCtaLink | IContentfulSelect

function renderGenericCTA(cta: ICTA) {
  if ((cta as IContentfulCtaLink).fields.url) {
    return <CTALink {...transformCTAWithBackground(cta as IContentfulCtaLink)} />
  }
  if ((cta as IContentfulSelect).fields.options) {
    return <LocationSelect {...transformSelect(cta as IContentfulSelect)} />
  }
}

function transformHeroForCareersPage({ fields }: IContentfulHeroForCareersPage) {
  return {
    ...fields,
    mode: fields.mode && Mode[fields.mode],
    layout: getLayoutFromData(fields.alignment),
    footnote: fields.footnote && documentToHtmlString(fields.footnote),
    media: fields.media && transformVideoOrImage(fields.media),
    renderCta: () => fields.heroCta && renderGenericCTA(fields.heroCta),
  }
}
